import productReducer from "./productReducer";

export * from './productActions';
export default productReducer;